<div class="pageheader">
    <div class="page-title">
        <h1>Identity clients</h1>
        <div class="btn-group">
            <button class="btn btn-link" (click)="refresh()">Refresh <ep-svg-icon icon="repeat"></ep-svg-icon></button>
            <app-change-log-link *bizPermissionRequired="'Identity_Action_Client_ShowLog'" [title]="'Identity clients log'">
                <app-change-log-link-entity type="Application"></app-change-log-link-entity>
            </app-change-log-link>
        </div>
    </div>
</div>

<dx-data-grid biz-grid [selection]='{ mode: "none" }' [dataSource]='clients()' (onInitNewRow)="onInitNewRow($event)" (onRowInserting)="onRowInserting($event)" (onRowUpdating)="onRowUpdating($event)"
    (onRowRemoving)="onRowRemoving($event)">

    <dxo-editing mode="row" [allowUpdating]="allowUpdating()" [allowAdding]="allowAdding()" [allowDeleting]="allowDeleting()">
        <dxo-popup title="Identity clients" [showTitle]="true"></dxo-popup>
    </dxo-editing>

    <dxo-column-fixing [enabled]="true"></dxo-column-fixing>

    <dxi-column dataField="ClientId" caption="Client id" dataType="string" sortOrder="asc">
        <dxi-validation-rule type="required"></dxi-validation-rule>
    </dxi-column>

    <dxi-column dataField="ClientSecret" caption="Client secret" cellTemplate="clientSecretTemplate">
        <dxi-validation-rule type="required"></dxi-validation-rule>
    </dxi-column>

    <dxi-column dataField="DisplayName" caption="Display name" dataType="string">
        <dxi-validation-rule type="required"></dxi-validation-rule>
    </dxi-column>

    <dxi-column dataField="Scopes" caption="Scopes" cellTemplate="scopesTemplate" editCellTemplate="scopesEditTemplate" [calculateSortValue]="calculateScopesSortValue"
        [calculateFilterExpression]="calculateScopesArrayFilterExpression">
        <dxo-header-filter [dataSource]="getScopesHeaderFilterData()"></dxo-header-filter>
    </dxi-column>

    <dxi-column dataField="RedirectUri" caption="Redirect uri" dataType="string">
    </dxi-column>

    <dxi-column dataField="PostLogoutRedirectUri" caption="Post-logout redirect uri" dataType="string">
    </dxi-column>

    <dxi-column type="buttons">
        <dxi-button name="edit"></dxi-button>
        <dxi-button name="delete"></dxi-button>
        <dxi-button text="Show Log" template="logTemplate" [visible]="allowShowLog()">
        </dxi-button>
    </dxi-column>

    <ng-container *dxTemplate="let cell of 'logTemplate'">
        <app-change-log-link *bizPermissionRequired="'Identity_Action_Client_ShowLog'" [title]="'Logs for ' + cell.data.DisplayName" [showIcon]="false" classNames="dx-link">
            <app-change-log-link-entity type="Application" [id]="cell.data.Id"></app-change-log-link-entity>
        </app-change-log-link>
    </ng-container>

    <div *dxTemplate="let cell of 'clientSecretTemplate'">
        @if (cell.data.HasClientSecret) {
        <span>&#x2022;&#x2022;&#x2022;&#x2022;&#x2022;&#x2022;</span>
        }
    </div>

    <ng-container *dxTemplate="let cell of 'scopesTemplate'">
        <dx-tag-box [dataSource]="scopes()" [(value)]="cell.value" displayExpr="DisplayName" valueExpr="Name" placeholder="Select scopes..." applyValueMode="useButtons" [showSelectionControls]="true"
            [disabled]="true">
        </dx-tag-box>
    </ng-container>

    <ng-container *dxTemplate="let cell of 'scopesEditTemplate'">
        <dx-tag-box [dataSource]="scopes()" [(value)]="cell.value" displayExpr="DisplayName" valueExpr="Name" placeholder="Select scopes..." applyValueMode="useButtons" [showSelectionControls]="true"
            [disabled]="false" (onValueChanged)="onValueChanged($event, cell)">
        </dx-tag-box>
    </ng-container>
</dx-data-grid>
